import { Link } from "react-router-dom";
import { Card, CardBody, Col } from "reactstrap";
import { P } from "../../../AbstractElements";
import { Href, LinkUnderlinesTitle } from "../../../Constants/Constants";
import { LinkUnderlinesData, LinkUnderlinesSubTitle } from "../../../Data/UiKits/NavigateLinks";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const LinkUnderlines = () => {
  return (
    <Col xxl="3" sm="6">
      <Card className="height-equal">
        <CommonCardHeader title={LinkUnderlinesTitle} span={LinkUnderlinesSubTitle} />
        <CardBody>
          {LinkUnderlinesData.map((item, index) => (
            <P key={index}>
              <Link className={`link-underline-${item}`} to={Href}>
                {item} underline
              </Link>
            </P>
          ))}
        </CardBody>
      </Card>
    </Col>
  );
};

export default LinkUnderlines;
